import { Alert } from '@mui/material'
import React from 'react'
import { useAppTranslations } from '../../utils/hooks/useAppTranslations'

const ErrorAlert: React.FC<{ message: string }> = ({ message }) => {
  const t = useAppTranslations()
  return <Alert severity="error">{`${t('commons.error')}: ${message}`}</Alert>
}
export default ErrorAlert
